var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['containerDash bg-costeaContainer overflow-auto', 
      {'extendMenu': _vm.dashboard.topBarExtendMenu}, 
      {'compressedMenu': _vm.dashboard.topBarExtendMenu == false}]},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }